import { LinkedinIcon, FacebookIcon, TwitterIcon } from '@koaly/koaly-ui-icons';
import { getColorToken } from '@koaly/mixins';
import React from 'react';
import styled from 'styled-components';
import { List } from '../List/List.js';
import { ListItem } from '../List/ListItem.js';

const StyledList = styled(List) `
  svg {
    fill: ${getColorToken('800', 'primary')};

    path {
      fill: ${getColorToken('800', 'primary')};
    }
  }
`;
const SocialMediaList = ({ linkedin, facebook, twitter }) => {
    return (React.createElement(StyledList, { direction: "horizontal", spaceBetween: 8 },
        linkedin && (React.createElement(ListItem, { key: "linkedin" },
            React.createElement("a", { target: "_blank", rel: "noreferrer", href: linkedin },
                React.createElement(LinkedinIcon, { width: 20, height: 20, title: "linkedin" })))),
        facebook && (React.createElement(ListItem, { key: "facebook" },
            React.createElement("a", { target: "_blank", rel: "noreferrer", href: facebook },
                React.createElement(FacebookIcon, { width: 20, height: 20, title: "facebook" })))),
        twitter && (React.createElement(ListItem, { key: "twitter" },
            React.createElement("a", { target: "_blank", rel: "noreferrer", href: twitter },
                React.createElement(TwitterIcon, { width: 20, height: 20, title: "twitter" }))))));
};

export { SocialMediaList };
//# sourceMappingURL=SocialMediaList.js.map
